import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-inclusion-index-informations',
  imports: [TranslateModule],
  templateUrl: './inclusion-index-informations.component.html',
  styleUrl: './inclusion-index-informations.component.css'
})
export class InclusionIndexInformationsComponent {

  constructor(private dialogRef : MatDialogRef<InclusionIndexInformationsComponent> ){}

  closeDialog() {
   this.dialogRef.close();
  }

}
